import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

const initApp = async () => {
  // @ts-ignore
  if (!window.ywConfig) {
    try {
      const response = await fetch('./yw_manifest.json');
      const config = await response.json();
      // @ts-ignore
      window.ywConfig = config;
    } catch (error) {
      console.error("Failed to load yw_manifest.json", error);
    }
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
};

initApp();
